var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"filter-badge",class:[_vm.active ? 'filter-badge-active' : ''],on:{"click":_vm.selectSubCategory}},[_vm._v(" "+_vm._s(_vm.subCategory.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }